export default {
  'nav.home': '首頁',
  'nav.media': '媒體報導',
  'nav.videos': '影片專區',

  'hero.title1': '國際扶輪和平意象',
  'hero.title2': '澎湖和平意象紀念碑',
  'hero.subtitle': '讓和平從澎湖出發，讓世界看見台灣',
  'hero.cta.videos': '觀看影片',
  'hero.cta.media': '媒體報導',

  'quote.text': '有些地方，會因為一座建築被記住；而有些地方，則會因為一個理念，被世界看見。',
  'quote.label': '和平理念',
  'quote.attribution': '— 國際扶輪',

  'intro.label': '專案簡介',
  'intro.text': '2026 年 5 月 26 日，我們齊聚在澎湖國際廣場，共同見證「國際扶輪和平意象」公共藝術作品正式竣工。這不只是一座公共藝術，更是一份來自臺灣獻給世界的和平祝福。',
  'intro.text2': '台南和平扶輪社自 2023 年開始提出興建和平意象的理念與想法，從籌備設計、動工到正式完成，背後集結的是來自台灣 12 個扶輪地區的扶輪人與台商團體共同的信念與努力。',
  'intro.cta.media': '媒體報導',
  'intro.cta.videos': '觀看影片',

  'design.label': '設計理念',
  'design.title': '設計理念',
  'design.title2': '一座以時間、語言與和平為核心的公共藝術',
  'design.card1.title': '12 根立柱',
  'design.card1.desc': '象徵臺灣 12 個扶輪地區攜手同行，共同推動和平理念。',
  'design.card2.title': '和平鴿與橄欖枝',
  'design.card2.desc': '中央和平鴿銜著橄欖枝，象徵希望、包容與世界和平。',
  'design.card3.title': '213 種和平文字',
  'design.card3.desc': '作品正面以 213 種世界不同語言的「和平」文字設計而成，象徵人類對和平的共同渴望。',
  'design.card4.title': '23.5 度台灣圖案',
  'design.card4.desc': '作品由傾斜 23.5 度的台灣圖案所支撐，呼應地球地軸傾斜角度，讓陽光直射台灣圖案。',
  'design.card5.title': '日晷與時間',
  'design.card5.desc': '陽光隨時間移動，金屬環上鏤空數字的日影能指出時間。時間持續流轉，而和平的追求，也因時間累積而更有實現的機會。',
  'design.card6.title': '澎湖與世界',
  'design.card6.desc': '澎湖是臺灣海洋的重要門戶，也是讓世界停下腳步、感受文化與交流的島嶼。',

  'penghu.label': '為什麼選在澎湖',
  'penghu.title': '為什麼選在澎湖？',
  'penghu.text': '我們選擇將這份「和平意象」設立在澎湖，因為澎湖不只是臺灣海洋的重要門戶，更是能讓世界停下腳步、感受文化與交流的島嶼。未來，這座國際扶輪和平意象公共藝術，除了成為澎湖新的地標，也將成為和平教育、國際交流的重要象徵。',

  'future.label': '未來願景',
  'future.title': '讓和平被聽見，也被世界記住',
  'future.text1': '每年，我們也將持續舉辦和平鐘敲鐘與和平產業論壇活動，讓和平不只是一句口號，而是可以實踐、傳承、被聽見、被世界記住的行動。',
  'future.text2': '謝謝所有參與這項計畫的夥伴們。因為大家的付出，讓來自臺灣的和平聲音，能夠在世界的每一個角落持續迴響。',
  'future.text3': '台灣是熱愛和平、自由、民主的地方。',
  'future.text4': 'Welcome to Taiwan！',
  'future.attribution': '— 台南和平扶輪社',

  'footer.title': '國際扶輪和平意象｜澎湖和平意象紀念碑',
  'footer.slogan': '讓和平從澎湖出發，讓世界看見台灣',
  'footer.nav': '導覽',
  'footer.lang': '語言',
  'footer.copyright': '© 2026 Rotary International Peace Monument. All Rights Reserved.',

  'media.title': '媒體報導',
  'media.label': '媒體報導',
  'media.subtitle': '國內媒體共同見證澎湖和平新地標',
  'media.cta.videos': '前往影片專區',
  'media.cta.home': '返回首頁',
  'media.section.title': '媒體報導紀錄',
  'media.card1.title': '國際扶輪和平意象藝術品圓滿竣工',
  'media.card1.titleEn': 'Rotary International Peace Imagery Public Artwork Completed',
  'media.card1.desc': '透過媒體報導，記錄「國際扶輪和平意象」公共藝術作品於澎湖國際廣場竣工揭碑的重要時刻，也讓更多人看見這座象徵和平、希望與國際交流的新地標。',
  'media.card2.title': '澎湖國際廣場見證和平意象揭幕',
  'media.card2.titleEn': 'Penghu International Plaza Witnesses the Unveiling of Peace Imagery',
  'media.card2.desc': '這段報導呈現扶輪夥伴與各界貴賓共同見證和平意象公共藝術的重要時刻，象徵臺灣以和平、自由與交流的精神連結世界。',
  'media.more.title': '更多媒體報導與活動紀錄將持續更新',
  'media.more.subtitle': '未來將持續整理相關媒體報導、活動紀錄與國際交流內容。',

  'media.readMore': '閱讀報導',

  'media.video.title': '影音報導',
  'media.video.subtitle': 'Video Reports',
  'media.video.desc': '透過影音紀錄，見證「國際扶輪和平意象」從開工、竣工到正式亮相的重要時刻。',
  'media.video.descEn': 'Through video reports, witness the important moments of the Rotary International Peace Imagery from groundbreaking to completion and unveiling.',

  'media.news.title': '新聞報導',
  'media.news.subtitle': 'News Coverage',
  'media.news.desc': '彙整各大媒體對「國際扶輪和平意象」公共藝術作品的新聞報導，記錄這座澎湖新地標從開工到竣工的重要歷程。',
  'media.news.descEn': 'A collection of news coverage documenting the journey of the Rotary International Peace Imagery public artwork, from groundbreaking to completion as a new landmark in Penghu.',

  'media.news1.media': '澎湖日報',
  'media.news1.date': '2025.10.15',
  'media.news1.title': '國際扶輪和平意象公共藝術開工',
  'media.news1.titleEn': 'Groundbreaking of the Rotary International Peace Imagery Public Artwork',
  'media.news1.desc': '澎湖日報報導台南和平扶輪社於澎湖國際廣場舉行「國際扶輪和平意象」開工典禮，象徵和平與團結的重要公共藝術工程正式啟動。',
  'media.news1.descEn': 'Penghu Daily reported on the groundbreaking ceremony of the Rotary International Peace Imagery at Penghu International Plaza, marking the beginning of an important public artwork symbolizing peace and unity.',
  'media.news1.link': 'https://penghudaily.blogspot.com/2025/10/blog-post_173.html?m=1#google_vignette',

  'media.news2.media': '中央社 CNA',
  'media.news2.date': '2026.05.26',
  'media.news2.title': '澎湖新地標，國際扶輪和平意象藝術作品亮相',
  'media.news2.titleEn': 'Penghu\'s New Landmark: Rotary International Peace Imagery Unveiled',
  'media.news2.desc': '中央社報導「國際扶輪和平意象」公共藝術作品於馬公第三漁港國際廣場舉行竣工暨捐贈儀式，未來將成為澎湖新地標與和平象徵。',
  'media.news2.descEn': 'CNA reported the completion and donation ceremony of the Rotary International Peace Imagery public artwork at Penghu International Plaza, marking it as a new landmark and symbol of peace.',
  'media.news2.link': 'https://www.cna.com.tw/news/aloc/202605260194.aspx',

  'media.news3.media': '自由時報',
  'media.news3.date': '2026.05.26',
  'media.news3.title': '國際扶輪和平意象公共藝術作品亮相',
  'media.news3.titleEn': 'Rotary International Peace Imagery Public Artwork Unveiled',
  'media.news3.desc': '自由時報報導國際扶輪和平意象公共藝術作品於澎湖亮相，呈現和平、希望與國際交流的精神。',
  'media.news3.descEn': 'Liberty Times reported the unveiling of the Rotary International Peace Imagery public artwork in Penghu, highlighting the spirit of peace, hope, and international exchange.',
  'media.news3.link': 'https://news.ltn.com.tw/news/life/breakingnews/5450259',

  'media.news4.media': 'Yahoo 新聞',
  'media.news4.date': '2026.05.26',
  'media.news4.title': '澎湖新地標，國際扶輪和平意象藝術作品亮相',
  'media.news4.titleEn': 'Penghu\'s New Landmark: Rotary International Peace Imagery Unveiled',
  'media.news4.desc': 'Yahoo 新聞轉載中央社報導，記錄象徵和平與希望的「國際扶輪和平意象」公共藝術作品正式亮相。',
  'media.news4.descEn': 'Yahoo News republished CNA\'s report on the official unveiling of the Rotary International Peace Imagery, a public artwork symbolizing peace and hope.',
  'media.news4.link': 'https://tw.news.yahoo.com/%E6%BE%8E%E6%B9%96%E6%96%B0%E5%9C%B0%E6%A8%99-%E5%9C%8B%E9%9A%9B%E6%89%B6%E8%BC%AA%E5%92%8C%E5%B9%B3%E6%84%8F%E8%B1%A1%E8%97%9D%E8%A1%93%E4%BD%9C%E5%93%81%E4%BA%AE%E7%9B%B8-%E5%9C%96-081021179.html?guccounter=1',

  'media.photo.title': '媒體新聞圖片',
  'media.photo.subtitle': 'Photo News',
  'media.photo.desc': '透過圖片新聞，紀錄國際扶輪和平意象公共藝術作品正式亮相的現場畫面與重要時刻。',
  'media.photo.descEn': 'Photo news documenting the unveiling of the Rotary International Peace Imagery public artwork and its important moments.',

  'media.photo1.media': 'Yahoo 新聞',
  'media.photo1.date': '2026.05.26',
  'media.photo1.title': '國際扶輪和平意象藝術作品亮相（圖）',
  'media.photo1.titleEn': 'Rotary International Peace Imagery Public Artwork Unveiled - Photo',
  'media.photo1.desc': '圖片新聞紀錄「國際扶輪和平意象」公共藝術作品於澎湖正式亮相的重要畫面。',
  'media.photo1.descEn': 'A photo news report documenting the unveiling of the Rotary International Peace Imagery public artwork in Penghu.',
  'media.photo1.link': 'https://tw.news.yahoo.com/%E6%BE%8E%E6%B9%96%E6%96%B0%E5%9C%B0%E6%A8%99-%E5%9C%8B%E9%9A%9B%E6%89%B6%E8%BC%AA%E5%92%8C%E5%B9%B3%E6%84%8F%E8%B1%A1%E8%97%9D%E8%A1%93%E4%BD%9C%E5%93%81%E4%BA%AE%E7%9B%B8-%E5%9C%96-081021179.html?guccounter=1',

  'media.photo2.media': 'Yahoo 新聞',
  'media.photo2.date': '2026.05.26',
  'media.photo2.title': '國際扶輪和平意象藝術作品亮相 1（圖）',
  'media.photo2.titleEn': 'Rotary International Peace Imagery Public Artwork Unveiled 1 - Photo',
  'media.photo2.desc': '圖片報導呈現和平意象公共藝術作品亮相現場，記錄澎湖新地標的重要時刻。',
  'media.photo2.descEn': 'This photo report captures the unveiling of the peace imagery public artwork and the important moment of Penghu\'s new landmark.',
  'media.photo2.link': 'https://tw.news.yahoo.com/%E5%9C%8B%E9%9A%9B%E6%89%B6%E8%BC%AA%E5%92%8C%E5%B9%B3%E6%84%8F%E8%B1%A1%E8%97%9D%E8%A1%93%E4%BD%9C%E5%93%81%E4%BA%AE%E7%9B%B8-1-%E5%9C%96-081024895.html',

  'media.photo3.media': 'Yahoo 新聞',
  'media.photo3.date': '2026.05.26',
  'media.photo3.title': '國際扶輪和平意象藝術作品亮相 2（圖）',
  'media.photo3.titleEn': 'Rotary International Peace Imagery Public Artwork Unveiled 2 - Photo',
  'media.photo3.desc': '圖片新聞延伸紀錄國際扶輪和平意象公共藝術作品亮相與現場活動畫面。',
  'media.photo3.descEn': 'An extended photo news record of the unveiling ceremony and on-site moments of the Rotary International Peace Imagery public artwork.',
  'media.photo3.link': 'https://tw.news.yahoo.com/%E5%9C%8B%E9%9A%9B%E6%89%B6%E8%BC%AA%E5%92%8C%E5%B9%B3%E6%84%8F%E8%B1%A1%E8%97%9D%E8%A1%93%E4%BD%9C%E5%93%81%E4%BA%AE%E7%9B%B8-2-%E5%9C%96-081026727.html',

  'videos.title': '影片專區',
  'videos.label': '影片專區',
  'videos.subtitle': '從影像中，看見和平意象的誕生與精神',
  'videos.cta.play': '播放影片',
  'videos.cta.media': '媒體報導',
  'videos.feature.label': '主影片',
  'videos.feature.title': '關於「國際扶輪和平意象紀念碑」',
  'videos.feature.title2': '',
  'videos.feature.desc': '這支影片記錄了「國際扶輪和平意象紀念碑」的緣起、設計理念與精神象徵。從和平鴿、橄欖枝、12 根立柱、213 種和平文字，到日晷與時間的設計，這座公共藝術不只是澎湖的新地標，更是一份由台灣出發、獻給世界的和平祝福。',
  'videos.feature.play': '播放影片',
  'videos.chapters.title': '影片重點',
  'videos.card1.title': '和平鐘',
  'videos.card1.desc': '象徵和平的聲音被敲響，也代表讓和平理念持續傳遞、被聽見、被世界記住。',
  'videos.card2.title': '12 個扶輪地區',
  'videos.card2.desc': '代表臺灣 12 個扶輪地區攜手推動和平理念。',
  'videos.card3.title': '213 種和平文字',
  'videos.card3.desc': '以世界不同語言書寫和平，呈現人類共同的渴望。',
  'videos.card4.title': '時間與和平',
  'videos.card4.desc': '日晷設計象徵時間流轉，也提醒和平需要長期累積與實踐。',
};